import Loadable from '@townsquare/loadable';
import { rovoRoute } from '@townsquare/routes/rovo-view';
import { rovoEntitlementResource } from '@townsquare/rovo/entitlement';

const RovoViewLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "chat-view" */ './components/RovoView'),
  loading: () => null,
});

rovoRoute.component = RovoViewLoadable;
rovoRoute.resources = [rovoEntitlementResource];

export const rovoRouterRoute = rovoRoute;
